// const files = require.context('./', false, /[A-Za-z0-9-_,\s]+\.json$/i);
const i18nAlias = window.globalData.merchant.i18n
let files;

switch(i18nAlias) {
  case ('pet'):
    files = require.context('./', false, /ipetbooking-[A-Za-z0-9-_,\s]+\.json$/i);
    break;
  case('massage'):
    files = require.context('./', false, /massage-[A-Za-z0-9-_,\s]+\.json$/i);
    break;
  case('beauty'): 
    default:
    files = require.context('./', false, /dingbeauty-[A-Za-z0-9-_,\s]+\.json$/i);
}
// if(process.env.VUE_APP_MODE === 'jtails' && process.env.VUE_APP_MODE === 'ipetbooking') {
//   files = require.context('./', false, /ipetbooking-[A-Za-z0-9-_,\s]+\.json$/i);
// } else {
//   files = require.context('./', false,  /dingbeauty-[A-Za-z0-9-_,\s]+\.json$/i);
// }

const locales = {};
  
files.keys()
  .forEach(key => {
    const matched = key.match(/\/([^/]+)-([^/]+)\.json$/);
    if(matched && matched.length > 1 ) {
      const fileName = matched[2];
      locales[fileName] = files(key)
    }
  });
console.log(locales)
export default locales;
